<template>
  <pr-box :title="titleBox">

    <div slot="buttons-header">
      <v-btn icon :to="{ name: 'zoho-report-group-form', params: { id: 'new' }}" v-if="!widget">
        <v-icon color="white">add</v-icon>
      </v-btn>
    </div>

    <div>

      <v-data-table
        :headers="headers"
        :items="resources"
        :total-items="totalResources"
        :pagination.sync="orderSync"
        :no-data-text="noDataAvailable"
        :hide-actions="true"
        class="elevation-0">

        <template slot="items" slot-scope="props">

          <td>
            {{ props.item.email }}
          </td>
          <td>
            {{ props.item.db_name }}
          </td>
          <td>
            {{ props.item.table_name }}
          </td>
          <td class="text-xs-center">

            <v-btn color="primary" flat icon @click="goToForm(props.item.id)">
              <v-icon>mode_edit</v-icon>
            </v-btn>

            <v-btn flat icon color="error" @click="destroy(props.item.id)">
              <v-icon>delete</v-icon>
            </v-btn>

          </td>
        </template>
      </v-data-table>
      <pr-pagination :paginator="paginator"></pr-pagination>
    </div>
  </pr-box>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import ZohoReportService from '@/features/zoho-report/ZohoReportService';

export default {
  name: 'zoho-report-group-list',
  mixins: [CrudMixin],
  props: {
    widget: {
      default: false,
    },
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('attributes.zoho.email'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.zoho.db_name'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('attributes.zoho.table_name'),
          sortable: false,
          align: 'left',
        },
        {
          text: this.$t('views.fields.actions'),
          sortable: false,
          align: 'right',
        },
      ],
    };
  },
  methods: {
    initCrud() {
      this.serviceType = ZohoReportService;
      this.routerName = 'zoho-report-group';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/zoho-report/ZohoReportGroupList.vue